import styled from 'styled-components';

import { getTheme } from './util/theme';

export const LandingPage = styled.section`
  background: linear-gradient(
    0deg,
    ${getTheme('black')} 0%,
    ${getTheme('mediumBlue')} 100%
  );
  display: flex;
  height: 100vh;
  justify-content: space-between;

  .landing__image-wrapper {
    background-image: url('/assets/statue-of-liberty.png');
    background-position: 25% 50%;
    background-size: cover;
    flex-basis: 50%;
    max-width: 50%;
  }

  .landing__login-wrapper {
    align-items: center;
    color: ${getTheme('white')};
    display: flex;
    flex-basis: 50%;
    flex-direction: column;
    justify-content: center;
    max-width: 50%;
  }

  .landing__heading {
    color: ${getTheme('white')};
    text-transform: uppercase;
  }

  .landing__title {
    margin-bottom: ${getTheme('doubleSpace')};
  }

  .landing__login {
    align-items: center;
    display: flex;
    font-size: 0.875rem;
    justify-content: center;
    padding: ${getTheme('halfSpace')};
    -webkit-appearance: none;

    &:before {
      content: url(/assets/icon-google.svg);
      display: inline-block;
      height: 20px;
      margin-right: ${getTheme('halfSpace')};
      width: 20px;
    }
  }
`;

export const Header = styled.header`
  background-color: ${getTheme('black')};
  display: flex;
  justify-content: flex-end;
  margin-bottom: ${getTheme('fourxSpace')};
  padding: ${getTheme('halfSpace')} ${getTheme('space')};

  .header__logout {
    background-color: transparent;
    color: ${getTheme('white')};
    font-weight: bold;
    padding: ${getTheme('quarterSpace')} ${getTheme('halfSpace')};
    text-transform: uppercase;
    transition: background-color 0.2s ease-out;
    -webkit-appearance: none;

    &:hover {
      background-color: ${getTheme('darkBlue')};
    }
  }
`;



// WEBPACK FOOTER //
// ./src/styled-components.js